import React from 'react';

const Loading = ({ message = 'Cargando...', size = 'medium' }) => {
  const sizeMap = {
    small: { spinner: 30, text: 12 },
    medium: { spinner: 50, text: 16 },
    large: { spinner: 70, text: 20 }
  };

  const dimensions = sizeMap[size] || sizeMap.medium;

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        {/* Spinner animado */}
        <div style={{
          ...spinnerStyle,
          width: dimensions.spinner,
          height: dimensions.spinner,
          borderWidth: Math.max(3, dimensions.spinner / 15)
        }}></div>

        {/* Mensaje de carga */}
        <p style={{
          ...messageStyle,
          fontSize: dimensions.text
        }}>{message}</p>
      </div>
    </div>
  );
};

// Estilos
const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  width: '100%',
  padding: '20px',
};

const contentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
};

const spinnerStyle = {
  border: '3px solid rgba(102, 126, 234, 0.1)',
  borderTop: '3px solid #667eea',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const messageStyle = {
  color: '#666',
  fontWeight: '500',
  margin: 0,
  fontFamily: 'system-ui, -apple-system, sans-serif',
};

export default Loading;